import React from 'react';
import CalendlyModal from '../components/CalendlyModal';
import Chat from '../components/Chat';
import CookieConsent from '../components/CookieConsent';
import Features from '../components/Features';
import Footer from '../components/Footer';
import { MuktaVaani } from '../components/GlobalThemes';
import Header from '../components/Header';
import SEO from '../components/SEO';
import useLangRedirect from '../hooks/useLangRedirect';
import usePageContext from '../hooks/usePageContext';
import WebpProvider from '../providers/WebpProvider';

type Props = {
  promotionalPage?: 'gen' | 'remax' | 'immovlan';
};

const TemplateWrapper: React.FC<Props> = ({
  children,
  promotionalPage = 'immovlan',
}) => {
  useLangRedirect();
  const { title } = usePageContext();
  const [calendlyModalIsOpen, updateCalendlyModalIsOpen] = React.useState(
    false,
  );

  return (
    <WebpProvider>
      <MuktaVaani />
      <SEO title={title} />
      <Header
        updateCalendlyModalIsOpen={updateCalendlyModalIsOpen}
        calendlyModalIsOpen={calendlyModalIsOpen}
        promotionalPage={promotionalPage}
      />
      {children}
      <Footer promotionalPage={promotionalPage} />
      <CalendlyModal
        updateCalendlyModalIsOpen={updateCalendlyModalIsOpen}
        calendlyModalIsOpen={calendlyModalIsOpen}
      />
      <CookieConsent />
      <Chat />
    </WebpProvider>
  );
};

const FeaturesRemaxPage = () => {
  return (
    <TemplateWrapper promotionalPage="immovlan">
      <Features promotionalPage="immovlan" />
    </TemplateWrapper>
  );
};

export default FeaturesRemaxPage;
